'use strict';
module.exports = function () {
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

    sizes.forEach(function (size) {
        var selector = '.collapsible-' + size + ' .title';
        var titleBar = '.collapsible-' + size;
        var indexSize = sizes.indexOf(size);
        $('body').on('click', selector, function (e) {
            e.preventDefault();
            e.stopPropagation();
            var clickedTitle = e.target;
            sizes.forEach(function (subSize) {
                if (sizes.indexOf(subSize) <= indexSize) {
                    var currentBlock = $(clickedTitle).parents('.collapsible-' + subSize);
                    if (currentBlock.hasClass('active')) {
                        currentBlock.removeClass('active').find('.content, .card-body').slideUp();
                        $(clickedTitle).attr('aria-expanded', false);
                    } else {
                        $(clickedTitle).parents('.collapsible-' + subSize).removeClass('active');
                        currentBlock.addClass('active').find('.content, .card-body').slideDown();
                        $(clickedTitle).attr('aria-expanded', true);
                    }
                }
            });
        });

        // allow for entire accordion title bar to be clicked
        $('body').on('click', titleBar, function (e) {
            $(e.target).find('.title').trigger('click');
        });
    });
};
